import axios from "axios"
import config from "config/config"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import Miniwidget from "./Miniwidget"
import { Col, Row } from "reactstrap"
import DoctorsCard from "./doctorsCard.jsx"
import RatingPerDayCard from "./RatingPerDayCard"
import MostRatedDoctorCard from "./MostRatedDoctorCard "
import ReviewBox from "../../newcomponents/ReviewBox.jsx"
import MiniCards from "newcomponents/mini-cards"

function VitalDashboard() {
  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const mode = useSelector(state => state.Layout.layoutMode)
  const userData = useSelector(state => state.Login.userData)
  const [report, setReport] = React.useState([])
  const [reviews, setReviews] = React.useState([])
  const [avgRating, setAvgRating] = React.useState(0)
  const [mostRatedDoctor, setMostRatedDoctor] = React.useState({})
  const [doctors, setDoctors] = React.useState([])
  const [reviewsPerDay, setReviewsPerDay] = useState([])
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const dates = Object.keys(reviewsPerDay)
  const counts = dates.map(date => reviewsPerDay[date].count)
  const chartOptions = {
    options: {
      chart: {
        id: "reviews-per-day",
        type: "bar",
        toolbar: { show: false },
      },
      xaxis: {
        categories: dates,
        title: { text: "Date" },
      },
      yaxis: {
        title: { text: "Number of Reviews" },
      },
      dataLabels: {
        enabled: true,
      },
      tooltip: {
        custom: ({ series, seriesIndex, dataPointIndex, w }) => {
          const date = w.globals.labels[dataPointIndex]
          const texts = reviewsPerDay[date].texts
          return `<div>
                  <strong>${date}</strong><br/>
                  ${texts.map(t => `<p>${t}</p>`).join("")}
                </div>`
        },
      },
    },
    series: [
      {
        name: "Reviews",
        data: counts,
      },
    ],
  }

  const fetchData = async () => {
    const integrationId = isConsolidatedView
      ? organizations
          .map(org => org.Organization?.VitalsIntegrations?.[0]?.id)
          .filter(Boolean)
          .join(",")
      : activeOrganization?.VitalsIntegrations?.[0]?.id

    if (!integrationId) return

    try {
      const response = await axios.get(
        `${config.backendUrl}/vitals/getVitalData?integrationId=${integrationId}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )
      if (response.status >= 200 && response.status < 300) {
        console.log(response.data)
        setDoctors(response.data.doctors)
        setMostRatedDoctor({ ...response.data.mostRatedDoctor })
        setAvgRating(response.data.avgReviewRating)
        setReviews(response.data.reviews)
        setReviewsPerDay(response.data.reviewsPerDay)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  useEffect(() => {
    setDoctors([])
    setMostRatedDoctor({ rating: 0 }) 
    setReviews([])
    setAvgRating(0)
    setReviewsPerDay([])
    fetchData()
  }, [activeOrganization, isConsolidatedView, organizations])

  useEffect(() => {
    if (doctors && doctors.length > 0 && reviews && reviews?.length) {
      let count = 0
      let sum = 0
      for (const review of reviews) {
        count++
        sum = sum + review.rating
      }

      const average_rating = sum / count

      setReport([
        {
          title: "Doctors",
          iconClass: "doctor",
          total: doctors.length,
          average: "+11%",
          badgecolor: "info",
        },
        {
          title: "Reviews",
          iconClass: "message-draw",
          total: reviews.length,
          average: "-29%",
          badgecolor: "danger",
        },
        {
          title: "Average Rating",
          iconClass: "star",
          total: avgRating.toFixed(2),
          average: "0%",
          badgecolor: "warning",
        },
      ])
    }
  }, [
    activeOrganization,
    doctors,
    reviews,
    avgRating,
    isConsolidatedView,
    organizations,
  ])

  return (
    <div
      style={{
        padding: "0px",
      }}
      className="container-fluid"
    >
      {/* Top mini widgets */}
      <MiniCards reports={report} mode={mode} />

      {/* Row with two cards side by side */}
      <Row>
        {/* Most Rated Doctor Card */}
        <Col xl="4" md="6">
          <MostRatedDoctorCard doctor={mostRatedDoctor} />
        </Col>
        {/* Doctors List Card */}
        <Col xl="8" md="6">
          <DoctorsCard doctors={doctors} />
        </Col>
        {/* Rating Per Day Card */}
        <Col xl="12" md="12">
          <RatingPerDayCard
            reviews={reviews}
            avgRating={avgRating}
            chartOptions={chartOptions}
          />
        </Col>
        {/* Review Boxes */}
        <Col xl="12" md="12">
          <Row>
            <ReviewBox mode={mode} reviews={reviews} platform="vitals" />
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default VitalDashboard
